import { render, staticRenderFns } from "./TablesUploader.vue?vue&type=template&id=554b747c&scoped=true&"
import script from "./TablesUploader.vue?vue&type=script&lang=js&"
export * from "./TablesUploader.vue?vue&type=script&lang=js&"
import style0 from "./TablesUploader.vue?vue&type=style&index=0&id=554b747c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b747c",
  null
  
)

export default component.exports